import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faImage} from "@fortawesome/free-solid-svg-icons";

// An item may have no image at all, so a grey placeholder takes the image's place and size.
const ItemImage = ({src, alt, className}) => {
    if (src) {
        return <img src={src} alt={alt} className={className}/>;
    }

    return (
        <div role="img" aria-label="Kein Bild vorhanden" className={`flex items-center justify-center bg-gray-100 text-gray-300 ${className}`}>
            <FontAwesomeIcon icon={faImage} className="w-1/3 h-1/3"/>
        </div>
    );
};

export default ItemImage;
